import { render, staticRenderFns } from "./CommonSmallPartOfSidebar.vue?vue&type=template&id=b711c7fc&lang=pug&"
import script from "./CommonSmallPartOfSidebar.vue?vue&type=script&lang=ts&"
export * from "./CommonSmallPartOfSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./CommonSmallPartOfSidebar.vue?vue&type=style&index=0&id=b711c7fc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports